import axios from "axios";
import { api } from "./api_route";


export const allOrganizationNotice = async (payload) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/all`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const organizationNoticeTemplate = async (params) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/all/${params ? params : ''}`);
    return response;
  } catch (error) {
    throw error;
  }
};



export const saveNoticeSection = async (payload) => {
  try {
    const response = await axios.post(`${api}/noticeTemplates/save/${payload.templateId}`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createAndUpdateNoticeSection = async (payload) => {
  try {
    const response = await axios.post(`${api}/noticeTemplates/createAndUpdate${payload.templateId ? `/${payload.templateId}` : ""}`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};


export const viewNotice = async (id) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/notice/${id}`,
      {
    responseType: "blob",
  }
);
  
    return response.data; 
  } catch (error) {
    throw error;
  }
};

export const previewNotice = async (values) => {
  try {
    const response = await axios.post(
      `${api}/noticeTemplates/preview`,
      values,
      {
        responseType: "blob", 
      }
    );

  
    return response.data; 
  } catch (error) {
    throw error;
  }
};

export const deleteNoticeTemplate = async (id) => {
  try {
    const response = await axios.post(`${api}/noticeTemplates/deleteNotice/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Notice Source Images



export const createNoticeSrcImages = async (formData) => {
  try {
    const response = await axios.post(
      `${api}/noticeTemplates/createNoticeSrcImages`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        
        timeout: 300000, 
      }
    );

   
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
  }
};


export const getAllNoticeSrcImages = async (values) => {
  try {
   const response = await axios.get(
  `${api}/noticeTemplates/getAllNoticeSrcImages`);

   
     return response.data;
  } catch (error) {
    throw error;
  }
};


export const deleteNoticeImage = async (id) => {
  try {
    const response = await axios.post(`${api}/noticeTemplates/deleteImage/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};


// Update to your NoticeGeneration component

export const generateOrgNotice = async (formData) => {
  const { findValueArray, ...data } = formData;
  try {
    const response = await axios.post(`${api}/noticeTemplates/generate`, {
      organizationId: formData.organizationId,
      caseTypeId: formData.tableName,
      findColumn: formData.findColumnId,
      findValues: findValueArray,
      noticeTemplateId: formData.noticeTemplateId,
      outputFormat: 'merged', // Ensure merged format
      includeCoverPage: true
    }, 
    
    {
      responseType: 'blob' // Return blob (PDF)
    });
    // return raw response.data (Blob)
    return response.data;
  } catch (error) {
    throw error;
  }
};




// const handleGenerateNotice = async () => {
//   if (!validateForm()) {
//     return;
//   }

//   setLoading(true);
  
//   try {
//     const response = await axios.post('/api/notices/generate', {
//       organizationId: formData.organizationId,
//       caseTypeId: formData.caseTypeId,
//       findColumn: formData.findColumn,
//       findValues: findValueArray,
//       noticeTemplateId: formData.noticeTemplateId
//     });

//     const { data } = response;
    
//     if (data.success) {
//       setPreviewData({
//         generatedNotices: data.data.generatedNotices,
//         summary: data.data.summary,
//         errors: data.data.errors,
//         timestamp: new Date().toISOString()
//       });
      
//       // Show success message
//       setAlert({
//         open: true,
//         severity: 'success',
//         message: `Successfully generated ${data.data.summary.successfulNotices} notices`
//       });
//     }
//   } catch (error) {
//     console.error('Error generating notices:', error);
//     setAlert({
//       open: true,
//       severity: 'error',
//       message: error.response?.data?.message || 'Failed to generate notices'
//     });
//   } finally {
//     setLoading(false);
//   }
// };

// // Download notice function
// const downloadNotice = async (fileName) => {
//   try {
//     const response = await axios.get(`/api/notices/download/${fileName}`, {
//       responseType: 'blob'
//     });
    
//     const url = window.URL.createObjectURL(new Blob([response.data]));
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', fileName);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   } catch (error) {
//     console.error('Error downloading notice:', error);
//     setAlert({
//       open: true,
//       severity: 'error',
//       message: 'Failed to download notice'
//     });
//   }
// };